import React from 'react';

import * as Actions from './actions';

import { SPAM_MODERATION_ORGANIZATION_ID } from '../../../../../../constants/moderation';

const ACTIONS = [
    { type: 'email_action', event: false, component: Actions.EmailAction },
    { type: 'attendee_creation_action', event: false, component: Actions.AttendeeCreationAction },
    { type: 'revert_action', event: false, component: Actions.RevertAction },
    { type: 'set_spam_score_action', event: true, component: Actions.SetSpamScoreAction },
    { type: 'ban_organizer_action', event: true, component: Actions.BanOrganizerAction }
];

export class TransitionActionHandler {
    #action;
    #actions;
    #component;

    constructor(action) {
        this.#action = action;
        this.#actions = ACTIONS;
        this.#component = this.#actions.find(act => act.type === this.#action.type);
    }

    validate() {
        if (!this.#component) {
            throw new Error(`${this.#action} is not valid, please provide a valid action`);
        }
    }

    get component() {
        this.validate();
        return this.#component.component;
    }

    static get_allowed_actions = organizationId => {
        const is_event_spam = organizationId === SPAM_MODERATION_ORGANIZATION_ID;
        return ACTIONS.filter(ac => ac.event === is_event_spam).map(ac => ac.type);
    };
}

const TransitionActionComponent = ({ organizationId, flowId, action, handleAction, handleActionObject }) => {
    if (!action || !action.type) {
        return null;
    }
    const ActionComponent = new TransitionActionHandler(action).component;
    return <ActionComponent organizationId={organizationId} flowId={flowId} action={action} handleAction={handleAction} handleActionObject={handleActionObject} />;
};

export default TransitionActionComponent;
